<template>
    <div class="localhighlight-panel" ref="localHighlights" v-if="getData.length">
        <div class="grid list-card">
            <div v-for="item in getData" class="card-item" :class="{'expanded':item.monthlyAverage}">
                <div class="item">
                    <img loading="lazy" :alt="item.title" :title="item.title" :src="glb.cdnUrl + 'images/desktop/dpp/'+ item.image">
                    <div :class="{longDesc:item.description && item.description.length > 60}">
                        <p class="capitalize singleline">{{item.title}}</p>
                        <p v-if="item.value" class="f4 text-bold">{{item.value}}</p>
                        <div class="f7 longdesp">
                            <span v-html="item.description"></span>
                            <button type="button" class="see-more link f7" v-if="item.monthlyAverage && !showChart" @click="toggleMonthlyAvg()">Show More Monthly Average <i class="f7 icon-angle-down"></i></button>
                        </div>
                    </div>
                </div>
                <div v-if="showChart && item.monthlyAverage" class="chart">
                    <mvtLocalHighlightTempDetail :monthlyAverage="item.monthlyAverage" @toggle="toggleMonthlyAvg"></mvtLocalHighlightTempDetail>
                </div>
            </div>
        </div>
        <div class="m-t-2" v-if="needShowMore">
            <button type="button"  @click="toggle" class="link">Show More</button>
        </div>
    </div>
</template>

<script src="./mvt-localhighlight.js"></script>

<style lang="scss">
    @use "./mvt-localhighlight.scss" as *;
</style>